import { useState, type ReactNode } from 'react';
import { Boton } from '../../components/ui.js';
import './guia.css';

/**
 * La guía de una pantalla de la primera sesión (estado «Primera vez» de
 * Entrenar activo, §7 de UI_UX_SPEC.md).
 *
 * Sale mientras el usuario no haya registrado NINGUNA serie en su vida, y se va
 * sola con la primera: no hace falta guardar que se ha visto, porque el dato
 * que la apaga ya existe. «Entendido» la cierra antes, para esta pantalla.
 *
 * No es un modal ni un recorrido por pasos: se entrena con el móvil en una
 * mano, y una capa encima de «Guardar serie» es exactamente lo que no puede
 * haber. Son cuatro frases, y la segunda es la que importa: los números vienen
 * puestos, y si se ha hecho lo que toca, es una pulsación (CA-2.1).
 */
export function GuiaPrimeraSesion(): ReactNode {
  const [cerrada, setCerrada] = useState(false);
  if (cerrada) return null;

  return (
    // Compacta a propósito: la primera versión ocupaba un tercio del móvil y
    // dejaba «Guardar serie» en el borde y «¿Por qué?» fuera de la vista, justo
    // lo que la guía dice que hay que usar (visto en la captura a 412 px).
    <section className="guia-sesion" aria-labelledby="guia-sesion-titulo">
      <div className="guia-sesion__cabecera">
        <h2 id="guia-sesion-titulo" className="guia-sesion__titulo">
          Tu primera sesión, en cuatro cosas
        </h2>
        <Boton variante="texto" className="guia-sesion__cerrar" onClick={() => setCerrada(true)}>
          Entendido
        </Boton>
      </div>
      <ol className="guia-sesion__lista">
        <li>Un ejercicio cada vez.</li>
        <li>Los números vienen puestos: si lo has hecho así, guarda la serie.</li>
        <li>El descanso empieza solo al guardar.</li>
        <li>RIR: repeticiones que te quedaban. «¿Por qué?» explica cada carga.</li>
      </ol>
    </section>
  );
}
